export const PDF = 'PDF'
export const GEOJSON = 'GEOJSON'
export const CSV = 'CSV'
export const K_FIL = 'K_FIL'


// WEBPACK FOOTER //
// ./src/constants/formats.js